// extracted by mini-css-extract-plugin
export default {"about":"About_about__+2wRI","container":"About_container__wJ13R"};